import React from 'react'
import PropTypes from 'prop-types'
import Loader from 'react-loaders'
import { Text } from 'shared/components'
import { buttonSizes, buttonVariations } from './variations'
import styles from './styles'
import { applySizes, applyVariations } from './helpers'

const Button = ({
  to,
  text,
  loading,
  children,
  variation,
  size,
  css,
  title,
  primary,
  secondary,
  plain,
  outlined,
  small,
  medium,
  large,
  circle,
  disabled,
  ...props
}) => {
  const btnSizes = { medium, large, small }
  const btnVariations = { primary, secondary, plain }

  const withTitle = (p) =>
    title ? (
      <>
        {p.children}
        <Text style={{ margin: '0 4px' }}>{title}</Text>
      </>
    ) : (
      <>{p.children}</>
    )
  const RenderComponent = (p) => {
    if (props.as) {
      return <props.as {...p} {...(to ? { to: to } : {})} />
    }

    return React.createElement('button', { ...p }, withTitle(p))
  }

  return (
    <RenderComponent
      css={[
        styles.btn,
        applySizes(btnSizes, size, styles),
        applyVariations(btnVariations, variation, styles),
        css,
      ]}
      {...props}
      disabled={disabled || loading}
    >
      {/* @TODO: Find Loader design and update */}
      {loading ? (
        <>
          <Loader type="ball-pulse" css={styles.loader} />
        </>
      ) : (
        text || children
      )}
    </RenderComponent>
  )
}

Button.propTypes = {
  as: PropTypes.node,
  to: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  variation: PropTypes.oneOf(Object.values(buttonVariations)),
  size: PropTypes.oneOf(Object.values(buttonSizes)),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  plain: PropTypes.bool,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  small: PropTypes.bool,
  medium: PropTypes.bool,
  large: PropTypes.bool,
  circle: PropTypes.bool,
  outlined: PropTypes.bool,
  css: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}
export default Button
export { buttonSizes, buttonVariations } from './variations'
